import { useCallback, useMemo } from 'react';

import { UserType } from '@enums/index';

import {
    useLazyGetMenteeAchievementsQuery,
    useLazyGetMentorAchievementsQuery,
} from '../api/professionalInfo';
import { AchievementsResponse } from '../types';

interface GetAchievementsProps {
    userType: UserType;
}

export default function useGetAchievements({ userType }: GetAchievementsProps) {
    const [getMentorAchievements, { data: mentorAchievements, isLoading: isMentorLoading }] =
        useLazyGetMentorAchievementsQuery();

    const [getMenteeAchievements, { data: menteeAchievements, isLoading: isMenteeLoading }] =
        useLazyGetMenteeAchievementsQuery();

    const isLoading = useMemo(
        () => isMentorLoading || isMenteeLoading,
        [isMentorLoading, isMenteeLoading]
    );

    const achievements = useMemo(
        () => mentorAchievements || menteeAchievements,
        [mentorAchievements, menteeAchievements]
    );

    const getAchievements = useCallback(
        (username: string) => {
            let experiencesData: AchievementsResponse;
            switch (userType) {
                case UserType.Mentor:
                    getMentorAchievements({ username });
                    break;
                case UserType.Mentee:
                    getMenteeAchievements({ username });
                    break;
                default:
                    break;
            }
            return experiencesData!;
        },
        [userType, getMentorAchievements, getMenteeAchievements]
    );
    return {
        getAchievements,
        isLoading,
        achievements,
    };
}
